// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniSignInStyles } from "@ces/App/Components/MiniSignIn/MiniSignIn";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color } from "@ces/XDL/Utilities";
import { css } from "styled-components";

miniSignInStyles.form = {
    css: css`
        padding: 17px;
        width: 342px;
    `,
};

miniSignInStyles.signInGridContainer = {
    gap: 12,
    offsetCss: css`
        flex-direction: column;
    `,
};

miniSignInStyles.titleGridItem = {
    width: 12,
    css: css`
        padding: 8px 8px 4px;
    `,
};

miniSignInStyles.title = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

miniSignInStyles.forgetPasswordLinkWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
    `,
};

miniSignInStyles.forgotPasswordLink = {
    color: "secondary",
    typographyProps: {
        weight: fontConfig.weight.bold,
        size: 10,
        lineHeight: "11px",
    },
    css: css`
        height: 9px;
    `,
};

miniSignInStyles.userNameGridItem = {
    width: 12,
};

miniSignInStyles.passwordGridItem = {
    width: 12,
};

miniSignInStyles.signInActionGridItem = {
    width: 12,
    css: css`
        align-items: center;
    `,
};

miniSignInStyles.signInButton = {
    css: css`
        margin-left: auto;
    `,
};

miniSignInStyles.separator = {
    css: css`
        width: 100%;
        margin-block: 8px;
        border: 1px solid ${color("common.ui4")};
    `,
};

miniSignInStyles.registerGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

miniSignInStyles.registerTitle = {
    variant: "h5",
    css: css`
        margin-bottom: 16px;
    `,
};

miniSignInStyles.registerSiteMessage = {
    size: 14,
    lineHeight: "22px",
};

miniSignInStyles.registerButtonGridItem = {
    width: 12,
};

miniSignInStyles.resetPasswordModal = {
    cssOverrides: {
        modalContent: css`
            overflow-y: hidden;
        `,
    },
};

miniSignInStyles.registrationButton = {
    css: css`
        margin-top: 4px;
        height: 33px;
    `,
};
